import React from "react";
import { Reveal, FadeUp } from "./primitives";

export const PageHero = ({ over, title, sub, children }) => (
  <section className="relative pt-40 pb-20 md:pt-48 md:pb-28 bg-wanm-offwhite grain overflow-hidden">
    <img src="/logos/isotype.png" alt="" aria-hidden
      className="absolute right-[-4%] top-[15%] w-[32vw] max-w-[440px] opacity-[0.07] pointer-events-none select-none" />
    <div className="relative z-10 mx-auto max-w-[1500px] px-5 md:px-10">
      <FadeUp>
        <span className="inline-flex items-center gap-2 text-sm font-black uppercase tracking-[0.25em] wanm-gradient-text">
          <span className="w-8 h-[2px] wanm-gradient-bg inline-block" />{over}
        </span>
      </FadeUp>
      <h1 className="mt-6 text-5xl sm:text-6xl lg:text-8xl font-black tracking-tighter leading-[0.88] text-wanm-dark max-w-5xl">
        <Reveal>{title}</Reveal>
      </h1>
      {sub && <FadeUp delay={0.15}><p className="mt-8 max-w-2xl text-lg md:text-2xl text-wanm-dark/70 leading-relaxed">{sub}</p></FadeUp>}
      {children && <FadeUp delay={0.25}><div className="mt-10">{children}</div></FadeUp>}
    </div>
  </section>
);

export default PageHero;
